export default __webpack_public_path__ + "static/media/category4.b8b1da28.png";